import React, { Component } from "react";
import ReactHtmlParser from "react-html-parser";

import ScrollView from "sub_components/Common/BloxScrollViewNew";
import { ReleaseApi } from "services/release";
import { TicketApi } from "services/ticket";

import { Utils } from "services/utils";
const CDN_URL = process.env.REACT_APP_CDN_URL;
const downArrowDefault = `${CDN_URL}common/down-nav-triangle-default-lg.svg`;
const upArrowDefault = `${CDN_URL}common/up-nav-triangle-default-lg.svg`;
const downArrowHover = `${CDN_URL}common/down-nav-triangle-hover-lg.svg`;
const upArrowHover = `${CDN_URL}common/up-nav-triangle-hover-lg.svg`;
const downArrowSelected = `${CDN_URL}common/down-nav-triangle-selected-lg.svg`;
const upArrowSelected = `${CDN_URL}common/up-nav-triangle-selected-lg.svg`;

class DetailView extends Component {
  constructor(props) {
    super(props);

    this.releaseApi = new ReleaseApi();
    this.state = {
      content: null,
      error: null,
      upArrow: null,
      downArrow: null,
    };
  }

  getArrows = (state, direction) => {
    switch (state) {
      case "HOVER":
        if (direction === "UP") {
          this.setState({ upArrow: upArrowHover });
        } else {
          this.setState({ downArrow: downArrowHover });
        }
        break;
      case "SELECTED":
        if (direction === "UP") {
          this.setState({ upArrow: upArrowSelected });
        } else {
          this.setState({ downArrow: downArrowSelected });
        }

        break;
      default:
        this.setState({ upArrow: upArrowDefault, downArrow: downArrowDefault });
        break;
    }
  };

  formatVersionLogistics = () => {
    const { params: { name: version, date } = {} } = this.props;
    return (
      version &&
      date && (
        <>
          <div className="version footer60">{version}</div>{" "}
          <div className="last-update footer31">
            LAST UPDATE:
            <div className="date footer40">
              {TicketApi.getFormattedMonthDayYear(date)}
            </div>
          </div>
        </>
      )
    );
  };

  getReleaseNotes = async (newVersion, date) => {
    let version = newVersion;
    try {
      version = version.split(" ").join("");
      let url = CDN_URL.split("cdn");

      url = url[0];
      url = `${url}cdn/release/${version}`;
      const response = await this.releaseApi.getReleaseNoteContent(url);
      Utils.isValidResponse(response)
        ? this.setState({ content: response.data, version, date })
        : this.setState({ error: "Error retrieving content" });
    } catch (e) {
      console.log(e);
      this.setState({ error: "Network error retrieving content" });
    }
  };
  setActiveScrollbar = () => {
    const scrollbar = document.querySelector(".ScrollbarsCustom");
    if (scrollbar) {
      this.setState({ scrollActive: true });
    }
  };
  removeActiveScrollbar = () => {
    const scrollbar = document.querySelector(".ScrollbarsCustom");
    if (scrollbar) {
      this.setState({ scrollActive: false });
    }
  };

  componentDidMount() {
    const { params: { name: version, date } = {} } = this.props;
    if (version && date) {
      this.getReleaseNotes(`${version}.html`, date);
    }

    this.getArrows();
  }

  render() {
    const { scrollActive, content } = this.state;
    const { onScrollStop, scrollTop, site } = this.props;
    return (
      <div className="detail-view">
        {
          <div className="wrapper">
            <div className="version-logistics">
              {this.formatVersionLogistics()}
            </div>

            <ScrollView
              scrollTop={scrollTop}
              onScrollStop={onScrollStop}
              module={scrollActive ? site.module : ""}
              onHoverOver={this.setActiveScrollbar}
              onHoverOut={this.removeActiveScrollbar}
            >
              <div className="content-wrapper">
                <div className="version-content body-copy">
                  {ReactHtmlParser(content)}
                </div>
              </div>
            </ScrollView>
          </div>
        }
        {/* {!content && (
					<div className='wrapper'>
						<div className='invalid-version'>
							Sorry, no release information available for that date
						</div>
					</div>
				)} */}
      </div>
    );
  }
}

export default DetailView;
